var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TagArrayInput"},[_vm._l((_vm.sortedTags),function(tag){return _c('TagInput',{key:tag.id,staticClass:"mr-1",attrs:{"value":tag,"excluded-tags":_vm.value},on:{"input":function($event){return _vm.tagChanged($event, tag)}}})}),_c('TagInput',{attrs:{"excluded-tags":_vm.value},on:{"input":_vm.addNewTag}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }